// angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';
import { Column } from 'devextreme/ui/data_grid';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// model import
import { WorkOrderReferencesResultDto } from '../../../_models/work-order-references-result-dto';

@Component({
    selector: 'app-work-order-editor-reference-selector',
    templateUrl: './work-order-editor-reference-selector.component.html',
    styleUrls: ['./work-order-editor-reference-selector.component.scss']
})
export class WorkOrderEditorReferenceSelectorComponent extends WorkOrderBaseComponent implements OnInit {
    @ViewChild('workOrderEditorReferenceSelectorPopup', { static: false })
    workOrderEditorReferenceSelectorPopup: DxPopupComponent;

    @Input() referenceTypeCode: string;
    @Input() communityId: number;

    @Output() onSelect = new EventEmitter<WorkOrderReferencesResultDto>();
    @Output() onClose = new EventEmitter<void>();

    visible = false;
    referenceColumns: Array<Column> = [];

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.show();
        this.populateReferenceColumns();
        this.populateReferences(null, this.communityId, this.referenceTypeCode);
    }

    show(): void {
        this.visible = true;
    }

    onShown(): void {
        this.workOrderEditorReferenceSelectorPopup.instance.repaint();
    }

    closeSelector(): void {
        this.visible = false;
        this.onClose.emit();
    }

    onReferenceSelection(record: WorkOrderReferencesResultDto): void {
        this.onSelect.emit(record);
        this.closeSelector();
    }

    private populateReferenceColumns(): void {
        switch (this.referenceTypeCode) {
            case 'P':
            case 'M':
                this.referenceColumns = [
                    { cellTemplate: 'actionTemplate', width: 90 },
                    {
                        dataField: 'reference',
                        dataType: 'string',
                        caption: 'Property Address',
                        cellTemplate: 'propertyTemplate'
                    },
                    { dataField: 'description', dataType: 'string', caption: 'Owner' },
                    {
                        dataField: 'attribute',
                        dataType: 'string',
                        caption: 'Customer Id',
                        cellTemplate: 'propertyTemplate'
                    }
                ];
                break;
            case 'A':
                this.referenceColumns = [
                    { cellTemplate: 'actionTemplate', width: 90 },
                    { dataField: 'reference', dataType: 'string', caption: 'Amenity' },
                    { dataField: 'description', dataType: 'string', caption: 'Description' },
                    { dataField: 'attribute', dataType: 'string', caption: 'Address' }
                ];
                break;
            case 'B':
                this.referenceColumns = [
                    { cellTemplate: 'actionTemplate', width: 90 },
                    { dataField: 'reference', dataType: 'string', caption: 'Area' },
                    { dataField: 'attribute', dataType: 'string', caption: 'Attribute' }
                ];
                break;
            case 'C':
                this.referenceColumns = [
                    { cellTemplate: 'actionTemplate', width: 90 },
                    { dataField: 'reference', dataType: 'string', caption: 'Description' },
                    { dataField: 'description', dataType: 'string', caption: 'StreetNumber' },
                    { dataField: 'attribute', dataType: 'string', caption: 'Street Name' }
                ];
                break;
        }
    }
}
